import { type FetchStakingOngoingUserParticipationsParams } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { type LockerRoomUnlock } from '../../models';
import { fetchStakingOngoingUserParticipations } from '../api/staking';

export const OngoingUserParticipationQueryKey = 'ongoingUserParticipation';

export const useOngoingUserParticipationsQuery = <TData = Array<LockerRoomUnlock> | undefined>(
	select: (data: Array<LockerRoomUnlock> | undefined) => TData,
	params?: FetchStakingOngoingUserParticipationsParams & { 'ids[]'?: string },
	options?: Omit<UseQueryOptions<Array<LockerRoomUnlock> | undefined, Error | null, TData>, 'queryFn' | 'queryKey'>
) =>
	useQuery({
		queryFn: () => fetchStakingOngoingUserParticipations({ ...params }),
		queryKey: [OngoingUserParticipationQueryKey, params],
		...options,
		select
	});
